<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para"><a id="page_5"></a>Dedicated to our former comrades aboard USS <em>McKean</em> (DD-784) and USS <em>Lafayette</em> (SSBN-616). The ships are both gone, but we will always be shipmates.</p>
<p class="para"> </p>
<p class="para">Thanks to Mike and Angela Pelke for your friendship as well as your sharp eyes.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?1f56c736